import Reflux from "reflux";
import { qualifyUrl } from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
import fetch, { fetchPeriodically } from "logic/rest/FetchProvider";
import { singletonStore, singletonActions } from "logic/singleton";
export const TIME_BASED_ROTATION_STRATEGY = "org.graylog2.indexer.rotation.strategies.TimeBasedRotationStrategy";
export const NOOP_RETENTION_STRATEGY = "org.graylog2.indexer.retention.strategies.NoopRetentionStrategy";
export const TIME_BASED_SIZE_OPTIMIZING_ROTATION_STRATEGY = "org.graylog2.indexer.rotation.strategies.TimeBasedSizeOptimizingStrategy";
export const ARCHIVE_RETENTION_STRATEGY = "org.graylog.plugins.archive.indexer.retention.strategies.ArchiveRetentionStrategy";
export const TIME_BASED_SIZE_OPTIMIZING_ROTATION_STRATEGY_TYPE = "org.graylog2.indexer.rotation.strategies.TimeBasedSizeOptimizingStrategyConfig";
export const RETENTION = "retention";
export const IndicesActions = singletonActions(
  "core.Indices",
  () => Reflux.createActions({
    list: { asyncResult: true },
    listAll: { asyncResult: true },
    close: { asyncResult: true },
    delete: { asyncResult: true },
    multiple: { asyncResult: true },
    reopen: { asyncResult: true },
    subscribe: { asyncResult: false },
    unsubscribe: { asyncResult: false }
  })
);
export const IndicesStore = singletonStore(
  "core.Indices",
  () => Reflux.createStore({
    listenables: [IndicesActions],
    indices: void 0,
    closedIndices: void 0,
    registrations: {},
    getInitialState() {
      return { indices: this.indices, closedIndices: this.closedIndices };
    },
    list(indexSetId) {
      const urlList = qualifyUrl(ApiRoutes.IndicesApiController.list(indexSetId).url);
      const promise = fetch("GET", urlList).then((response) => {
        this.indices = response.all.indices;
        this.closedIndices = response.closed.indices;
        this.trigger({ indices: this.indices, closedIndices: this.closedIndices });
        return { indices: this.indices, closedIndices: this.closedIndices };
      });
      IndicesActions.list.promise(promise);
    },
    listAll() {
      const urlList = qualifyUrl(ApiRoutes.IndicesApiController.listAll().url);
      const promise = fetch("GET", urlList).then((response) => {
        this.indices = response.all.indices;
        this.closedIndices = response.closed.indices;
        this.trigger({ indices: this.indices, closedIndices: this.closedIndices });
        return { indices: this.indices, closedIndices: this.closedIndices };
      });
      IndicesActions.listAll.promise(promise);
    },
    multiple() {
      const indexNames = Object.keys(this.registrations);
      if (!indexNames.length) {
        return;
      }
      const urlList = qualifyUrl(ApiRoutes.IndicesApiController.multiple().url);
      const request = { indices: indexNames };
      const promise = fetchPeriodically("POST", urlList, request).then((response) => {
        this.indices = [...this.indices, ...response];
        this.trigger({ indices: this.indices, closedIndices: this.closedIndices });
        return { indices: this.indices, closedIndices: this.closedIndices };
      });
      IndicesActions.multiple.promise(promise);
    },
    close(indexName) {
      const url = qualifyUrl(ApiRoutes.IndicesApiController.close(indexName).url);
      const promise = fetch("POST", url);
      IndicesActions.close.promise(promise);
    },
    delete(indexName) {
      const url = qualifyUrl(ApiRoutes.IndicesApiController.delete(indexName).url);
      const promise = fetch("DELETE", url);
      IndicesActions.delete.promise(promise);
    },
    reopen(indexName) {
      const url = qualifyUrl(ApiRoutes.IndicesApiController.reopen(indexName).url);
      const promise = fetch("POST", url);
      IndicesActions.reopen.promise(promise);
    },
    subscribe(indexName) {
      this.registrations[indexName] = this.registrations[indexName] ? this.registrations[indexName] + 1 : 1;
    },
    unsubscribe(indexName) {
      this.registrations[indexName] = this.registrations[indexName] > 0 ? this.registrations[indexName] - 1 : 0;
      if (this.registrations[indexName] === 0) {
        delete this.registrations[indexName];
      }
    }
  })
);
